/**
 * Deterministic CONTINUE target for multi-chapter campaign (M61).
 *
 * Policy:
 * 1. Prefer the highest unlocked chapter.
 * 2. Within it, first unlocked stage not yet cleared on Normal+.
 * 3. If every unlocked stage in that chapter is Normal+, return the last unlocked stage
 *    (mastery / replay target).
 */

import {
  listChapters,
  listChapterStages,
  STAGE_BY_ID
} from '../game/campaign/registry'
import {
  clearsUnlockNext,
  isChapterUnlocked,
  isStageUnlocked,
  type CampaignProgressStateV2
} from './campaignProgress'

export function resolveContinueStageId(state: CampaignProgressStateV2): string {
  const chapters = listChapters()
  let target = chapters[0]!
  for (const chapter of chapters) {
    if (isChapterUnlocked(chapter.id, state)) {
      target = chapter
    }
  }

  const stages = listChapterStages(target.id)
  let lastUnlocked: string | null = null
  for (const stage of stages) {
    if (!isStageUnlocked(stage.id, state)) continue
    lastUnlocked = stage.id
    const clears = state.stages[stage.id]?.clears
    if (!clears || !clearsUnlockNext(clears)) {
      return stage.id
    }
  }

  if (lastUnlocked) return lastUnlocked
  return stages[0]?.id ?? 'chapter1-stage1'
}

export function resolveContinueStageLabel(state: CampaignProgressStateV2): string {
  const id = resolveContinueStageId(state)
  return STAGE_BY_ID[id]?.displayLabel ?? id
}
